module.exports = __webpack_public_path__ + "media/images/avatar_vet_1-f0812914e61447bb8aa625debd60ecff.jpg";